import React, {useEffect} from 'react';
import GoogleMapReact from 'google-map-react';
import css from './Map.module.css';
import themes from "../../static/themes";
import {connect} from 'react-redux';
import {disableGps, enableGps} from "../../utils/gps";
import {boundsChanged, centerMapOnGps, zoomChanged} from "../../store/mapSlice";
import {Page, setGpsLocation, setMapLoaded} from "../../store/coreSlice";
import {startRefreshDaemon} from "../../utils/refresh";
import GpsMarker from "../Markers/GpsMarker";
import {useMapControl} from "../../utils/useMapControl";
import GpsCenterControl from "./GpsCenterControl";

const Map = (props) => {
	const centerGps = () => {
		// if( props.gpsLocation && window.map ) {
			props.centerMapOnGps();
			// window.map.panTo(window.maps.LatLng(props.gpsLocation[0], props.gpsLocation[1]));
		// }
	};

	useMapControl(window.map, window.maps ? window.maps.ControlPosition.RIGHT_BOTTOM : null, props.useGps && <GpsCenterControl onClick={centerGps}/>);

	const lastZoom = localStorage.getItem('lastZoom');
	const defaultZoom = lastZoom !== null ? +lastZoom : (props.page === Page.S2 ? 18 : 15);

	const lastBounds = localStorage.getItem('lastBounds');
	const defaultCenter = lastBounds !== null ? JSON.parse(lastBounds) : {lat: 42.2831, lng: -83.7478};

	useEffect(() => {
		if( window.map ) {
			if( props.showTraffic && !window.trafficLayer ) {
				window.trafficLayer = new window.maps.TrafficLayer();
				window.trafficLayer.setMap(window.map);
			} else if( !props.showTraffic && window.trafficLayer ) {
				window.trafficLayer.setMap(null);
				window.trafficLayer = null;
			}
		}
	}, [props.showTraffic]);

	useEffect(() => {
		if( window.map ) {
			if( props.useGps ) {
				enableGps();
			} else {
				disableGps();
			}
		}
	}, [props.useGps]);

	useEffect(() => {
		if( props.mapLoaded && props.bootstrapped ) {
			window.maps.event.addListener(window.map, 'idle', function () {
				updateBounds();
			});

			window.maps.event.addListener(window.map, 'zoom_changed', () => {
				props.zoomChanged(window.map.getZoom());
			});

			startRefreshDaemon();
			updateBounds(); // Race condition means it might not run. But it won't trigger twice.
		} // eslint-disable-next-line
	}, [props.mapLoaded, props.bootstrapped]);


	const getMapOptions = (maps) => {
		return {
			styles: props.theme && themes[props.theme] ? themes[props.theme] : themes['classic'],
			tilt: 0,
			mapTypeControl: true,
			clickableIcons: false,
			streetViewControl: true,
			mapTypeControlOptions: {
				mapTypeIds: ['roadmap', 'satellite', 'hybrid'],
				position: maps.ControlPosition.LEFT_BOTTOM,
				index: -1
			},
			fullscreenControlOptions: {
				position: maps.ControlPosition.RIGHT_BOTTOM
			}
		}
	};

	const handleApiLoaded = (map, maps) => {
		props.zoomChanged(defaultZoom);

		window.maps = maps;
		window.map = map;

		if( props.useGps )
			enableGps();

		// updateBounds(); // No, this should go in 'idle'

		if( props.showTraffic ) {
			window.trafficLayer = new window.maps.TrafficLayer();
			window.trafficLayer.setMap(window.map);
		}

		props.setMapLoaded(true);
	};


	const updateBounds = () => {
		const bounds = window.map.getBounds();
		const ne = bounds.getNorthEast();
		const sw = bounds.getSouthWest();
		props.boundsChanged([ [ne.lat(), ne.lng()], [sw.lat(), sw.lng()] ]);
	};

	return (
		<GoogleMapReact
			className={css.GoogleMapReact}
			defaultCenter={defaultCenter}
			defaultZoom={defaultZoom}
			bootstrapURLKeys={{ key: 'AIzaSyA71qxiDXkidCFLhJJ-IXabKFKOkVglOG4' }}
			yesIWantToUseGoogleMapApiInternals
			options={getMapOptions}
			onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
		>
			{props.useGps && props.gpsLocation && <GpsMarker lat={props.gpsLocation[0]} lng={props.gpsLocation[1]} /> }
			{props.children}
		</GoogleMapReact>
	);
};

Map.propTypes = {};

const mapStateToProps = (state) => {
	return {
		bootstrapped: state.core.bootstrapped,
		mapLoaded: state.core.mapLoaded,
		gpsLocation: state.core.gpsLocation,
		useGps: state.settings.useGps,
		showTraffic: state.settings.showTraffic,
		theme: state.settings.theme,
		page: state.core.page
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		boundsChanged: (bounds) => dispatch(boundsChanged(bounds)),
		zoomChanged: (zoom) => dispatch(zoomChanged(zoom)),
		setGpsLocation: (gpsLocation) => dispatch(setGpsLocation(gpsLocation)),
		setMapLoaded: (val) => dispatch(setMapLoaded(val)),
		centerMapOnGps: () => dispatch(centerMapOnGps())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Map);